export default __webpack_public_path__ + "static/media/import.3eb0df68.svg";